import React from 'react';
import styles from "./ListItem.module.scss";
import { flag, getNumberWithOrdinalWithSuperscript } from '../../../hooks/utils';

const ListItem = ({id, style, onMouseOver, onMouseOut, onClick, data, rank}) =>{

    const rankDisplay = rank ? (<span className={styles.rank}>{getNumberWithOrdinalWithSuperscript(rank)}</span>) : null;

    return( 
                <div
                    id={id}
                    style={style}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                    onClick={onClick} 
                    className={styles.listItem}>
                    {rankDisplay}
                    <div className={styles.cityName}>{data.city}</div>
                    <div className={styles.country}>
                        <span className={`${styles.countryName}`}>{data.country}</span>
                        <img src={flag(data.ISO2)} alt={data.city} className={styles.flag} />
                    </div>
                </div>

    )
}

export default ListItem;